import "./stats.css"
import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Chart from "react-apexcharts"
import { FaUsers, FaCalendarAlt } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

const d = new Date();


class AdminStatPlayers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            nb_active_players: 0,
            total_nb_players: 0,
            end_date: new Date().toISOString().substring(0, 10),
            start_date: new Date(d.setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),
            series_star: null,
            player_retention: {},
        }
    }

    componentDidMount = async () => {
        await this.loadStats()
    }

    loadStats = async () => {
        const players = await AdminService.getPlayersStats(this.state.start_date, this.state.end_date)
        console.log(players)
        let nb_months = [], nb_days = [], nb_signin_days = [], nb_unique_signin_days = [], nb_unique_signin_weeks = []
        Object.keys(players.created_players_by_month).map(key => nb_months.push(players.created_players_by_month[key]))
        Object.keys(players.created_players_by_day).map(key => nb_days.push(players.created_players_by_day[key]))
        Object.keys(players.signin_by_day).map(key => nb_signin_days.push(players.signin_by_day[key]))
        Object.keys(players.unique_signin_by_day).map(key => nb_unique_signin_days.push(players.unique_signin_by_day[key]))
        Object.keys(players.unique_signin_by_week).map(key => nb_unique_signin_weeks.push(players.unique_signin_by_week[key]))
        this.setState({
            options_days: { chart: { id: "players-day" }, xaxis: { categories: Object.keys(players.created_players_by_day) } },
            options_signin_days: { chart: { id: "signin-day" }, xaxis: { categories: Object.keys(players.signin_by_day) } },
            options_unique_signin_days: { chart: { id: "unique-signin-day" }, xaxis: { categories: Object.keys(players.unique_signin_by_day) } },
            options_unique_signin_weeks: { chart: { id: "unique-signin-week" }, xaxis: { categories: Object.keys(players.unique_signin_by_week) } },
            options_months: { chart: { id: "players-month" }, xaxis: { categories: Object.keys(players.created_players_by_month) } },
            nb_months: [{ name: "players", data: nb_months }],
            nb_days: [{ name: "players", data: nb_days }],
            nb_signin_days: [{ name: "players", data: nb_signin_days }],
            nb_unique_signin_days: [{ name: "players", data: nb_unique_signin_days }],
            nb_unique_signin_weeks: [{ name: "unique players", data: nb_unique_signin_weeks }],
            nb_active_players: players.nb_active_players,
            total_nb_players: players.total_nb_players,
            player_retention: players.player_retention,
        })
    }

    render() {
        return (
            <AdminLayout 
                title="Players Statistics"
                breadcrumbs={[
                    { label: 'Statistics', href: '/admin/stats' },
                    { label: 'Players' }
                ]}
            >
                <div className="space-y-6">
                    {/* Header with Date Range */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                        <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                            <FaUsers className="text-blue-600" />
                            Players Statistics
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                    <FaCalendarAlt className="text-gray-500" />
                                    Start Date
                                </label>
                                <input 
                                    type="date" 
                                    defaultValue={this.state.start_date} 
                                    onChange={(e) => this.setState({ start_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                    <FaCalendarAlt className="text-gray-500" />
                                    End Date
                                </label>
                                <input 
                                    type="date" 
                                    defaultValue={this.state.end_date} 
                                    onChange={(e) => this.setState({ end_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Stats Table */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-50 to-cyan-50 px-6 py-3 border-b border-gray-200">
                            <h4 className="font-semibold text-gray-900">Player Overview</h4>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Active players</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Total players</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b border-gray-200">
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-blue-600">{this.state.nb_active_players}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-gray-900">{this.state.total_nb_players}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Player Retention */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-50 to-cyan-50 px-6 py-3 border-b border-gray-200">
                            <h4 className="font-semibold text-gray-900">Players Retention</h4>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">1 day</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">7 days</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">30 days</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">90 days</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Total players</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b border-gray-200">
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-green-600">{this.state.player_retention["1day"]}%</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-green-600">{this.state.player_retention["7days"]}%</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-blue-600">{this.state.player_retention["30days"]}%</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-blue-600">{this.state.player_retention["90days"]}%</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-gray-900">{this.state.player_retention.total}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Charts */}
                    <div className="grid grid-cols-1 gap-6">
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">New Players per Month</h4>
                            {this.state.nb_months && <Chart options={this.state.options_months} series={this.state.nb_months} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">New Players per Day</h4>
                            {this.state.nb_days && <Chart options={this.state.options_days} series={this.state.nb_days} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Sign-in per Day</h4>
                            {this.state.nb_signin_days && <Chart options={this.state.options_signin_days} series={this.state.nb_signin_days} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Unique Sign-in per Day</h4>
                            {this.state.nb_unique_signin_days && <Chart options={this.state.options_unique_signin_days} series={this.state.nb_unique_signin_days} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Unique Sign-in per Week</h4>
                            {this.state.nb_unique_signin_weeks && <Chart options={this.state.options_unique_signin_weeks} series={this.state.nb_unique_signin_weeks} type="bar" />}
                        </div>
                    </div>
                </div>
            </AdminLayout>
        )
    }
}

export default withTranslation()(AdminStatPlayers)